import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["enableInteraction"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/helpers/styled.js",
    _this = this;
/**
 * Helper file for extracting values from the theme configuration.
 */


import styled, { css } from 'styled-components';
import React from 'react';
import { withTheme } from '../core/ThemeProvider';
import Text from '../components/Text';
var InteractionContainer = styled.div.withConfig({
  displayName: "styled__InteractionContainer",
  componentId: "sc-1r6of0i-0"
})(["position:relative;display:inline-block;line-height:0;margin:0;vertical-align:top;pointer-events:none;z-index:0;"]);
export var Interaction = styled(withTheme(styled.div.withConfig({
  displayName: "styled__Interaction",
  componentId: "sc-1r6of0i-2"
})(function (_ref) {
  var _coreTheme$checkBoxIn, _coreTheme$checkBoxIn2, _coreTheme$checkBoxIn3, _coreTheme$checkBoxIn4;

  var desktopSize = _ref.desktopSize,
      mobileSize = _ref.mobileSize,
      coreTheme = _ref.coreTheme; // This is to handle theme configuration for the checkbox hover styles.

  var mobileHoverSize = (_coreTheme$checkBoxIn = (_coreTheme$checkBoxIn2 = coreTheme.checkBoxInput) === null || _coreTheme$checkBoxIn2 === void 0 ? void 0 : _coreTheme$checkBoxIn2.hoverXS) !== null && _coreTheme$checkBoxIn !== void 0 ? _coreTheme$checkBoxIn : mobileSize;
  var desktopHoverSize = (_coreTheme$checkBoxIn3 = (_coreTheme$checkBoxIn4 = coreTheme.checkBoxInput) === null || _coreTheme$checkBoxIn4 === void 0 ? void 0 : _coreTheme$checkBoxIn4.hoverXL) !== null && _coreTheme$checkBoxIn3 !== void 0 ? _coreTheme$checkBoxIn3 : desktopSize;
  return css(["position:absolute;width:100%;height:100%;border-radius:50%;opacity:0;transition:all 0.1s ease-in;z-index:-1;padding:", "px;top:-", "px;left:-", "px;@media (min-width:", "){padding:", "px;top:-", "px;left:-", "px;}"], mobileHoverSize || desktopHoverSize, mobileHoverSize || desktopHoverSize, mobileHoverSize || desktopHoverSize, coreTheme.brk_xs, desktopHoverSize, desktopHoverSize, desktopHoverSize);
}))).withConfig({
  displayName: "styled__Interaction",
  componentId: "sc-1r6of0i-1"
})({});
/**
 * Wraps the component and provides touch/click interaction effect.
 * @param StyledComponent Styled component.
 * @param desktopSize size of the interaction for desktop. In px.
 * @param mobileSize size of the interaction for mobile. In px.
 * @return New component with the interaction effect
 *
 * ```jsx
 *  const YourComponent_NowWithInteractionEffects = withClearInteraction(YourComponent);
 *  <YourComponent_NowWithInteractionEffects ... />
 * ```
 */

export var withClearInteraction = function withClearInteraction(StyledComponent, desktopSize, mobileSize) {
  var StyledComponentWithInteraction = withTheme(styled(StyledComponent).withConfig({
    displayName: "styled__StyledComponentWithInteraction",
    componentId: "sc-1r6of0i-3"
  })(["pointer-events:auto;", ";"], function (p) {
    return css([":hover{+ ", "{background-color:", ";opacity:0.8;}}:active{+ ", "{background-color:", ";opacity:0.5;}}"],
    /* sc-selector */
    Interaction, p.enableInteraction ? p.coreTheme.cl_sec_l1 : 'transparent',
    /* sc-selector */
    Interaction, p.enableInteraction ? p.coreTheme.cl_sec_l1 : 'transparent');
  }));

  var NewComponent = function NewComponent(_ref2) {
    var enableInteraction = _ref2.enableInteraction,
        rest = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/React.createElement(InteractionContainer, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(StyledComponentWithInteraction, _extends({}, rest, {
      enableInteraction: enableInteraction,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 9
      }
    })), /*#__PURE__*/React.createElement(Interaction, {
      desktopSize: desktopSize,
      mobileSize: mobileSize,
      enableInteraction: enableInteraction,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 9
      }
    }));
  };

  NewComponent.displayName = "".concat(StyledComponent.displayName, "__withClearInteraction") || null;
  return NewComponent;
};
export var getStyledText = function getStyledText(type, attrs) {
  return withStyledAttrs(Text, Object.assign({
    type: type
  }, attrs));
};
export var withStyledAttrs = function withStyledAttrs(Component, attrs) {
  return typeof attrs === 'function' ? styled(Component).attrs(attrs) : styled(Component).attrs(function () {
    return attrs;
  });
};